import * as React from 'react';
export var OverflowMenuContext = React.createContext({
  isBelowBreakpoint: false
});